<payee-popup title="Dokumentumok generálása">
  <mat-progress-spinner
    *ngIf="loading"
    mode="indeterminate"
    diameter="48"
  ></mat-progress-spinner>

  <div *ngIf="validationErrors" class="flex">
    <app-validation-errors
      [validationErrors]="validationErrors"
    ></app-validation-errors>

    <button
      payee-icon-button
      color="white"
      (click)="validationErrors = undefined"
    >
      <payee-icon name="trash-red"></payee-icon>
    </button>
  </div>

  <div
    *ngIf="dialogData && !loading && !validationErrors"
    class="comparison-container"
  >
    <!-- Debtor Section -->
    <div *ngIf="hasData(dialogData.debtor)" class="entity-section">
      <h3>Adós: {{ getEntityName(dialogData.debtor) }}</h3>
      <div class="comparison-grid">
        <div class="database-column">
          <h4>Adatbázis adatok</h4>
          <div *ngIf="dialogData.debtor.database" class="data-card">
            <div
              class="data-row"
              [class.mismatch]="isNameMismatch(dialogData.debtor)"
            >
              <strong>Név:</strong>
              {{
                dialogData.debtor.database.basicData?.name || "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isLongNameMismatch(dialogData.debtor)"
            >
              <strong>Hosszú név:</strong>
              {{
                dialogData.debtor.database.basicData?.long_name ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isTaxNumberMismatch(dialogData.debtor)"
            >
              <strong>Adószám:</strong>
              {{
                dialogData.debtor.database.basicData?.tax_number ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isTaxNumberRootMismatch(dialogData.debtor)"
            >
              <strong>Adószám gyökér:</strong>
              {{
                dialogData.debtor.database.basicData?.tax_number_root ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isPartyTypeMismatch(dialogData.debtor)"
            >
              <strong>Típus:</strong>
              {{
                dialogData.debtor.database.basicData?.partyType?.label ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="
                isStreetMismatch(dialogData.debtor) ||
                isSettlementMismatch(dialogData.debtor)
              "
            >
              <strong>Cím:</strong>
              {{
                dialogData.debtor.database.addressData?.street ||
                  "Nincs megadva"
              }}, {{ dialogData.debtor.database.addressData?.settlement || "" }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isPostcodeMismatch(dialogData.debtor)"
            >
              <strong>Irsz:</strong>
              {{
                dialogData.debtor.database.addressData?.postcode ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isCountryIsoMismatch(dialogData.debtor)"
            >
              <strong>Ország:</strong>
              {{
                dialogData.debtor.database.addressData?.country_iso ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.database.contactData"
              class="data-row"
              [class.mismatch]="isContactMismatch(dialogData.debtor)"
            >
              <strong>Kapcsolat:</strong>
              {{ dialogData.debtor.database.contactData.type }}:
              {{ dialogData.debtor.database.contactData.value }}
            </div>
            <div
              *ngIf="dialogData.debtor.database.bankAccountData"
              class="data-row"
              [class.mismatch]="isBankAccountMismatch(dialogData.debtor)"
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.debtor.database.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.database.bankAccountData"
              class="data-row"
              [class.mismatch]="isIbanMismatch(dialogData.debtor)"
            >
              <strong>IBAN:</strong>
              {{
                dialogData.debtor.database.bankAccountData.iban ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.database.bankAccountData"
              class="data-row"
              [class.mismatch]="isBbanMismatch(dialogData.debtor)"
            >
              <strong>BBAN:</strong>
              {{
                dialogData.debtor.database.bankAccountData.bban ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.database.representativeData"
              class="data-row"
              [class.mismatch]="isRepresentativeNameMismatch(dialogData.debtor)"
            >
              <strong>Képviselő név:</strong>
              {{
                dialogData.debtor.database.representativeData.name ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.database.representativeData"
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberMismatch(dialogData.debtor)
              "
            >
              <strong>Képviselő adószám:</strong>
              {{
                dialogData.debtor.database.representativeData.tax_number ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.database.representativeData"
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberRootMismatch(dialogData.debtor)
              "
            >
              <strong>Képviselő adószám gyökér:</strong>
              {{
                dialogData.debtor.database.representativeData.tax_number_root ||
                  "Nincs megadva"
              }}
            </div>
          </div>
          <div *ngIf="!dialogData.debtor.database" class="no-data">
            Nincs adatbázis adat
          </div>
        </div>
        <div class="company-search-column">
          <h4>Cégkeresési adatok</h4>
          <div *ngIf="dialogData.debtor.company_search" class="data-card">
            <div
              class="data-row"
              [class.mismatch]="isNameMismatch(dialogData.debtor)"
            >
              <strong>Név:</strong>
              {{
                dialogData.debtor.company_search.basicData?.name ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isLongNameMismatch(dialogData.debtor)"
            >
              <strong>Hosszú név:</strong>
              {{
                dialogData.debtor.company_search.basicData?.long_name ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isTaxNumberMismatch(dialogData.debtor)"
            >
              <strong>Adószám:</strong>
              {{
                dialogData.debtor.company_search.basicData?.tax_number ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isPartyTypeMismatch(dialogData.debtor)"
            >
              <strong>Típus:</strong>
              {{
                dialogData.debtor.company_search.basicData?.partyType?.label ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="
                isStreetMismatch(dialogData.debtor) ||
                isSettlementMismatch(dialogData.debtor)
              "
            >
              <strong>Cím:</strong>
              {{
                dialogData.debtor.company_search.addressData?.street ||
                  "Nincs megadva"
              }},
              {{
                dialogData.debtor.company_search.addressData?.settlement || ""
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isPostcodeMismatch(dialogData.debtor)"
            >
              <strong>Irsz:</strong>
              {{
                dialogData.debtor.company_search.addressData?.postcode ||
                  "Nincs megadva"
              }}
            </div>
            <div
              class="data-row"
              [class.mismatch]="isCountryIsoMismatch(dialogData.debtor)"
            >
              <strong>Ország:</strong>
              {{
                dialogData.debtor.company_search.addressData?.country_iso ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.company_search.contactData"
              class="data-row"
              [class.mismatch]="isContactMismatch(dialogData.debtor)"
            >
              <strong>Kapcsolat:</strong>
              {{ dialogData.debtor.company_search.contactData.type }}:
              {{
                dialogData.debtor.company_search.contactData.value ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.company_search.bankAccountData"
              class="data-row"
              [class.mismatch]="isBankAccountMismatch(dialogData.debtor)"
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.debtor.company_search.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.company_search.bankAccountData"
              class="data-row"
              [class.mismatch]="isIbanMismatch(dialogData.debtor)"
            >
              <strong>IBAN:</strong>
              {{
                dialogData.debtor.company_search.bankAccountData.iban ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.company_search.bankAccountData"
              class="data-row"
              [class.mismatch]="isBbanMismatch(dialogData.debtor)"
            >
              <strong>BBAN:</strong>
              {{
                dialogData.debtor.company_search.bankAccountData.bban ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.company_search.representativeData"
              class="data-row"
              [class.mismatch]="isRepresentativeNameMismatch(dialogData.debtor)"
            >
              <strong>Képviselő név:</strong>
              {{
                dialogData.debtor.company_search.representativeData.name ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.company_search.representativeData"
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberMismatch(dialogData.debtor)
              "
            >
              <strong>Képviselő adószám:</strong>
              {{
                dialogData.debtor.company_search.representativeData
                  .tax_number || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor.company_search.representativeData"
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberRootMismatch(dialogData.debtor)
              "
            >
              <strong>Képviselő adószám gyökér:</strong>
              {{
                dialogData.debtor.company_search.representativeData
                  .tax_number_root || "Nincs megadva"
              }}
            </div>
          </div>
          <div *ngIf="!dialogData.debtor.company_search" class="no-data">
            Nincs cégkeresési adat
          </div>
        </div>
      </div>
    </div>

    <!-- Debtor Representative Section -->
    <div
      *ngIf="hasData(dialogData.debtor_representative)"
      class="entity-section"
    >
      <h3>
        Adós képviselője: {{ getEntityName(dialogData.debtor_representative) }}
      </h3>
      <div class="comparison-grid">
        <div class="database-column">
          <h4>Adatbázis adatok</h4>
          <div
            *ngIf="dialogData.debtor_representative.database"
            class="data-card"
          >
            <div class="data-row">
              <strong>Név:</strong>
              {{
                dialogData.debtor_representative.database.basicData?.name ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám:</strong>
              {{
                dialogData.debtor_representative.database.basicData
                  ?.tax_number || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám gyökér:</strong>
              {{
                dialogData.debtor_representative.database.basicData
                  ?.tax_number_root || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Cím:</strong>
              {{
                dialogData.debtor_representative.database.addressData?.street ||
                  "Nincs megadva"
              }},
              {{
                dialogData.debtor_representative.database.addressData
                  ?.settlement || ""
              }}
            </div>
            <div class="data-row">
              <strong>Irsz:</strong>
              {{
                dialogData.debtor_representative.database.addressData
                  ?.postcode || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor_representative.database.contactData"
              class="data-row"
            >
              <strong>Kapcsolat:</strong>
              {{ dialogData.debtor_representative.database.contactData.type }}:
              {{ dialogData.debtor_representative.database.contactData.value }}
            </div>
            <div
              *ngIf="dialogData.debtor_representative.database.bankAccountData"
              class="data-row"
              [class.mismatch]="
                isBankAccountMismatch(dialogData.debtor_representative)
              "
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.debtor_representative.database.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor_representative.database.bankAccountData"
              class="data-row"
              [class.mismatch]="
                isIbanMismatch(dialogData.debtor_representative)
              "
            >
              <strong>IBAN:</strong>
              {{
                dialogData.debtor_representative.database.bankAccountData
                  .iban || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.debtor_representative.database.bankAccountData"
              class="data-row"
              [class.mismatch]="
                isBbanMismatch(dialogData.debtor_representative)
              "
            >
              <strong>BBAN:</strong>
              {{
                dialogData.debtor_representative.database.bankAccountData
                  .bban || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.database.representativeData
              "
              class="data-row"
              [class.mismatch]="
                isRepresentativeNameMismatch(dialogData.debtor_representative)
              "
            >
              <strong>Képviselő név:</strong>
              {{
                dialogData.debtor_representative.database.representativeData
                  .name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.database.representativeData
              "
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberMismatch(
                  dialogData.debtor_representative
                )
              "
            >
              <strong>Képviselő adószám:</strong>
              {{
                dialogData.debtor_representative.database.representativeData
                  .tax_number || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.database.representativeData
              "
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberRootMismatch(
                  dialogData.debtor_representative
                )
              "
            >
              <strong>Képviselő adószám gyökér:</strong>
              {{
                dialogData.debtor_representative.database.representativeData
                  .tax_number_root || "Nincs megadva"
              }}
            </div>
          </div>
          <div
            *ngIf="!dialogData.debtor_representative.database"
            class="no-data"
          >
            Nincs adatbázis adat
          </div>
        </div>
        <div class="company-search-column">
          <h4>Cégkeresési adatok</h4>
          <div
            *ngIf="dialogData.debtor_representative.company_search"
            class="data-card"
          >
            <div class="data-row">
              <strong>Név:</strong>
              {{
                dialogData.debtor_representative.company_search.basicData
                  ?.name || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám:</strong>
              {{
                dialogData.debtor_representative.company_search.basicData
                  ?.tax_number || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Cím:</strong>
              {{
                dialogData.debtor_representative.company_search.addressData
                  ?.street || "Nincs megadva"
              }},
              {{
                dialogData.debtor_representative.company_search.addressData
                  ?.settlement || ""
              }}
            </div>
            <div class="data-row">
              <strong>Irsz:</strong>
              {{
                dialogData.debtor_representative.company_search.addressData
                  ?.postcode || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.company_search.contactData
              "
              class="data-row"
            >
              <strong>Kapcsolat:</strong>
              {{
                dialogData.debtor_representative.company_search.contactData
                  .type
              }}:
              {{
                dialogData.debtor_representative.company_search.contactData
                  .value || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.company_search.bankAccountData
              "
              class="data-row"
              [class.mismatch]="
                isBankAccountMismatch(dialogData.debtor_representative)
              "
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.debtor_representative.company_search.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.company_search.bankAccountData
              "
              class="data-row"
              [class.mismatch]="
                isIbanMismatch(dialogData.debtor_representative)
              "
            >
              <strong>IBAN:</strong>
              {{
                dialogData.debtor_representative.company_search.bankAccountData
                  .iban || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.company_search.bankAccountData
              "
              class="data-row"
              [class.mismatch]="
                isBbanMismatch(dialogData.debtor_representative)
              "
            >
              <strong>BBAN:</strong>
              {{
                dialogData.debtor_representative.company_search.bankAccountData
                  .bban || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.company_search
                  .representativeData
              "
              class="data-row"
              [class.mismatch]="
                isRepresentativeNameMismatch(dialogData.debtor_representative)
              "
            >
              <strong>Képviselő név:</strong>
              {{
                dialogData.debtor_representative.company_search
                  .representativeData.name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.company_search
                  .representativeData
              "
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberMismatch(
                  dialogData.debtor_representative
                )
              "
            >
              <strong>Képviselő adószám:</strong>
              {{
                dialogData.debtor_representative.company_search
                  .representativeData.tax_number || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.debtor_representative.company_search
                  .representativeData
              "
              class="data-row"
              [class.mismatch]="
                isRepresentativeTaxNumberRootMismatch(
                  dialogData.debtor_representative
                )
              "
            >
              <strong>Képviselő adószám gyökér:</strong>
              {{
                dialogData.debtor_representative.company_search
                  .representativeData.tax_number_root || "Nincs megadva"
              }}
            </div>
          </div>
          <div
            *ngIf="!dialogData.debtor_representative.company_search"
            class="no-data"
          >
            Nincs cégkeresési adat
          </div>
        </div>
      </div>
    </div>

    <!-- Client Section -->
    <div *ngIf="hasData(dialogData.client)" class="entity-section">
      <h3>Hitelező: {{ getEntityName(dialogData.client) }}</h3>
      <div class="comparison-grid">
        <div class="database-column">
          <h4>Adatbázis adatok</h4>
          <div *ngIf="dialogData.client.database" class="data-card">
            <div class="data-row">
              <strong>Név:</strong>
              {{
                dialogData.client.database.basicData?.name || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Hosszú név:</strong>
              {{
                dialogData.client.database.basicData?.long_name ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám:</strong>
              {{
                dialogData.client.database.basicData?.tax_number ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám gyökér:</strong>
              {{
                dialogData.client.database.basicData?.tax_number_root ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Típus:</strong>
              {{
                dialogData.client.database.basicData?.partyType?.label ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Cím:</strong>
              {{
                dialogData.client.database.addressData?.street ||
                  "Nincs megadva"
              }}, {{ dialogData.client.database.addressData?.settlement || "" }}
            </div>
            <div class="data-row">
              <strong>Irsz:</strong>
              {{
                dialogData.client.database.addressData?.postcode ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client.database.contactData"
              class="data-row"
            >
              <strong>Kapcsolat:</strong>
              {{ dialogData.client.database.contactData.type }}:
              {{ dialogData.client.database.contactData.value }}
            </div>
            <div
              *ngIf="dialogData.client.database.bankAccountData"
              class="data-row"
              [class.mismatch]="isBankAccountMismatch(dialogData.client)"
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.client.database.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client.database.bankAccountData"
              class="data-row"
              [class.mismatch]="isIbanMismatch(dialogData.client)"
            >
              <strong>IBAN:</strong>
              {{
                dialogData.client.database.bankAccountData.iban ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client.database.bankAccountData"
              class="data-row"
              [class.mismatch]="isBbanMismatch(dialogData.client)"
            >
              <strong>BBAN:</strong>
              {{
                dialogData.client.database.bankAccountData.bban ||
                  "Nincs megadva"
              }}
            </div>
          </div>
          <div *ngIf="!dialogData.client.database" class="no-data">
            Nincs adatbázis adat
          </div>
        </div>
        <div class="company-search-column">
          <h4>Cégkeresési adatok</h4>
          <div *ngIf="dialogData.client.company_search" class="data-card">
            <div class="data-row">
              <strong>Név:</strong>
              {{
                dialogData.client.company_search.basicData?.name ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Hosszú név:</strong>
              {{
                dialogData.client.company_search.basicData?.long_name ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám:</strong>
              {{
                dialogData.client.company_search.basicData?.tax_number ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Típus:</strong>
              {{
                dialogData.client.company_search.basicData?.partyType?.label ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Cím:</strong>
              {{
                dialogData.client.company_search.addressData?.street ||
                  "Nincs megadva"
              }},
              {{
                dialogData.client.company_search.addressData?.settlement || ""
              }}
            </div>
            <div class="data-row">
              <strong>Irsz:</strong>
              {{
                dialogData.client.company_search.addressData?.postcode ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client.company_search.contactData"
              class="data-row"
            >
              <strong>Kapcsolat:</strong>
              {{ dialogData.client.company_search.contactData.type }}:
              {{
                dialogData.client.company_search.contactData.value ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client.company_search.bankAccountData"
              class="data-row"
              [class.mismatch]="isBankAccountMismatch(dialogData.client)"
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.client.company_search.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client.company_search.bankAccountData"
              class="data-row"
              [class.mismatch]="isIbanMismatch(dialogData.client)"
            >
              <strong>IBAN:</strong>
              {{
                dialogData.client.company_search.bankAccountData.iban ||
                  "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client.company_search.bankAccountData"
              class="data-row"
              [class.mismatch]="isBbanMismatch(dialogData.client)"
            >
              <strong>BBAN:</strong>
              {{
                dialogData.client.company_search.bankAccountData.bban ||
                  "Nincs megadva"
              }}
            </div>
          </div>
          <div *ngIf="!dialogData.client.company_search" class="no-data">
            Nincs cégkeresési adat
          </div>
        </div>
      </div>
    </div>

    <!-- Client Representative Section -->
    <div
      *ngIf="hasData(dialogData.client_representative)"
      class="entity-section"
    >
      <h3>
        Hitelező képviselője:
        {{ getEntityName(dialogData.client_representative) }}
      </h3>
      <div class="comparison-grid">
        <div class="database-column">
          <h4>Adatbázis adatok</h4>
          <div
            *ngIf="dialogData.client_representative.database"
            class="data-card"
          >
            <div class="data-row">
              <strong>Név:</strong>
              {{
                dialogData.client_representative.database.basicData?.name ||
                  "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám:</strong>
              {{
                dialogData.client_representative.database.basicData
                  ?.tax_number || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám gyökér:</strong>
              {{
                dialogData.client_representative.database.basicData
                  ?.tax_number_root || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Cím:</strong>
              {{
                dialogData.client_representative.database.addressData?.street ||
                  "Nincs megadva"
              }},
              {{
                dialogData.client_representative.database.addressData
                  ?.settlement || ""
              }}
            </div>
            <div class="data-row">
              <strong>Irsz:</strong>
              {{
                dialogData.client_representative.database.addressData
                  ?.postcode || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client_representative.database.contactData"
              class="data-row"
            >
              <strong>Kapcsolat:</strong>
              {{ dialogData.client_representative.database.contactData.type }}:
              {{ dialogData.client_representative.database.contactData.value }}
            </div>
            <div
              *ngIf="dialogData.client_representative.database.bankAccountData"
              class="data-row"
              [class.mismatch]="
                isBankAccountMismatch(dialogData.client_representative)
              "
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.client_representative.database.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client_representative.database.bankAccountData"
              class="data-row"
              [class.mismatch]="
                isIbanMismatch(dialogData.client_representative)
              "
            >
              <strong>IBAN:</strong>
              {{
                dialogData.client_representative.database.bankAccountData
                  .iban || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="dialogData.client_representative.database.bankAccountData"
              class="data-row"
              [class.mismatch]="
                isBbanMismatch(dialogData.client_representative)
              "
            >
              <strong>BBAN:</strong>
              {{
                dialogData.client_representative.database.bankAccountData
                  .bban || "Nincs megadva"
              }}
            </div>
          </div>
          <div
            *ngIf="!dialogData.client_representative.database"
            class="no-data"
          >
            Nincs adatbázis adat
          </div>
        </div>
        <div class="company-search-column">
          <h4>Cégkeresési adatok</h4>
          <div
            *ngIf="dialogData.client_representative.company_search"
            class="data-card"
          >
            <div class="data-row">
              <strong>Név:</strong>
              {{
                dialogData.client_representative.company_search.basicData
                  ?.name || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Adószám:</strong>
              {{
                dialogData.client_representative.company_search.basicData
                  ?.tax_number || "Nincs megadva"
              }}
            </div>
            <div class="data-row">
              <strong>Cím:</strong>
              {{
                dialogData.client_representative.company_search.addressData
                  ?.street || "Nincs megadva"
              }},
              {{
                dialogData.client_representative.company_search.addressData
                  ?.settlement || ""
              }}
            </div>
            <div class="data-row">
              <strong>Irsz:</strong>
              {{
                dialogData.client_representative.company_search.addressData
                  ?.postcode || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.client_representative.company_search.contactData
              "
              class="data-row"
            >
              <strong>Kapcsolat:</strong>
              {{
                dialogData.client_representative.company_search.contactData
                  .type
              }}:
              {{
                dialogData.client_representative.company_search.contactData
                  .value || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.client_representative.company_search.bankAccountData
              "
              class="data-row"
              [class.mismatch]="
                isBankAccountMismatch(dialogData.client_representative)
              "
            >
              <strong>Bankszámla:</strong>
              {{
                dialogData.client_representative.company_search.bankAccountData
                  .account_holder_name || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.client_representative.company_search.bankAccountData
              "
              class="data-row"
              [class.mismatch]="
                isIbanMismatch(dialogData.client_representative)
              "
            >
              <strong>IBAN:</strong>
              {{
                dialogData.client_representative.company_search.bankAccountData
                  .iban || "Nincs megadva"
              }}
            </div>
            <div
              *ngIf="
                dialogData.client_representative.company_search.bankAccountData
              "
              class="data-row"
              [class.mismatch]="
                isBbanMismatch(dialogData.client_representative)
              "
            >
              <strong>BBAN:</strong>
              {{
                dialogData.client_representative.company_search.bankAccountData
                  .bban || "Nincs megadva"
              }}
            </div>
          </div>
          <div
            *ngIf="!dialogData.client_representative.company_search"
            class="no-data"
          >
            Nincs cégkeresési adat
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="alert-green"
      width="wide"
      (click)="submit()"
      [disabled]="loading"
    >
      Generálás
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button payee-button color="alert-red" width="wide" mat-dialog-close>
      Mégse
    </button>
  </ng-template>
</payee-popup>
